/**
 * Tracker component module.
 * @module shared/components/Tracker
 *
 */
import {useEffect} from 'react';
import PropTypes from 'prop-types';
import axiosInstance from '../utils/axios';

/**
 * Tracker component
 * @name Tracker
 */
const Tracker = (props) => {
  const {category, feature, tracker, origin, onSuccess} = props;

  useEffect(() => axiosInstance.post('/user/tracking', {category, feature, tracker, origin})
    .then(res => {
      if (onSuccess) {
        onSuccess(res.data);
      }
    }), []);

  return '';
};

export default Tracker;

Tracker.propTypes = {
  /**
   * Tracker category name
   */
  category: PropTypes.string.isRequired,
  /**
   * Tracker feature name
   */
  feature: PropTypes.string.isRequired,
  /**
   * Tracker name/url
   */
  tracker: PropTypes.string.isRequired,
  /**
   * Tracker origin name/url
   */
  origin: PropTypes.string,
  /**
   * Function to call upon successful API call. Receives the created tracking ID.
   */
  onSuccess: PropTypes.func,
};
